import React from "react";
import UltimateTrousers from "../Garments/UltimateTrousers";

export default function UltimateTrousersPage() {
  return <UltimateTrousers />;
}
